<template>
  <v-dialog
    v-model="visible"
    persistent
    :fullscreen="isMobile"
    :transition="false"
    style="z-index: 9999"
    :max-width="maxWidth"
  >
    <v-card v-if="visible" class="pa-0" style="z-index: 9999">
      <div class="relative">
        <div id="pinMap"></div>

        <v-btn fab small :loading="gpsLoading" class="white gps-btn" @click="getCurrentLocation">
          <v-icon v-if="!gpsOff">gps_fixed</v-icon>
          <v-icon v-if="gpsOff">gps_off</v-icon>
        </v-btn>

        <div class="pin-marker">
          <img :src="pinIcon" />
          <div
            class="formatted-address"
            v-if="!geocoding && geocodeResult && geocodeResult.formatted_address"
          >
            {{ geocodeResult.formatted_address }}
          </div>
        </div>
      </div>
      <v-card-actions class="pin-on-map__actions">
        <v-spacer></v-spacer>
        <v-btn :flat="!isMobile" :depressed="isMobile" @click="close">{{
          $t('dropoff_address.form.cancel')
        }}</v-btn>
        <v-btn color="accent" :disabled="!confirmButtonEnable" depressed @click="confirm">{{
          $t('dropoff_address.form.confirm')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import L from 'leaflet'
import mapView from '../../mixins/map-view'
import addressHelper from '@/mixins/address-helper'
import { getPlaceGeoReverse } from '@/plugins/place'

const { filter, sortBy, reverse } = require('@/plugins/lodash')

export default {
  name: 'MapView',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    addressPoint: {
      required: false
    }
  },
  mixins: [mapView, addressHelper],
  data() {
    return {
      map: null,
      geocodeResult: null,
      gpsLoading: false,
      gpsOff: false,
      geocoding: false,
      latLng: null
    }
  },
  computed: {
    maxWidth() {
      var width = (screen && screen.width * 0.8) || 540
      if (width < 540) width = 540
      return `${width}px`
    },
    pinIcon() {
      return this.addressPoint && this.addressPoint.item_index === 0
        ? '/v1/assets/images/user_pickup.svg'
        : '/v1/assets/images/user_drop-off.svg'
    },
    confirmButtonEnable() {
      return this.geocodeResult && this.geocodeResult.formatted_address && true
    }
  },
  mounted() {
    console.log('addressPoint', this.addressPoint)
    this.loadGoogleMapApiJS().then(() => {
      this.initMap()
    })
  },
  methods: {
    initMap() {
      var lat = 10.771992000000001
      var lng = 106.698264
      const pickupPoint = this.$store.getters.orderFormPath && this.$store.getters.orderFormPath[0]

      const logList = this.$store.getters.addressList || []
      const recentLogs = filter(logList, (log) => {
        return log.is_search_history
      })
      const recentAddress = reverse(sortBy(recentLogs, 'logged_time'))

      if (this.addressPoint && this.addressPoint.lat && this.addressPoint.lng) {
        lat = this.addressPoint.lat
        lng = this.addressPoint.lng
      } else if (pickupPoint && pickupPoint.lat && pickupPoint.lng) {
        lat = pickupPoint.lat
        lng = pickupPoint.lng
      } else if (recentAddress && recentAddress.lat && recentAddress.lng) {
        lat = recentAddress.lat
        lng = recentAddress.lng
      }

      console.log('this.map', this.map)
      if (!this.map && lat && lng) {
        const center = [lat, lng]
        console.log('lat', center)

        this.map = L.map('pinMap', {
          zoomControl: false,
          attributionControl: false
        }).setView(center, 17)

        this.$_mapView_initMap()

        if (!this.isMobile) {
          L.control
            .zoom({
              position: 'topright'
            })
            .addTo(this.map)
        }

        this.map.on(
          'load',
          function () {
            console.log('loaded', this.map)
          }.bind(this)
        )

        this.map.on(
          'moveend',
          function (e) {
            this.onChangeMapCenter(e)
          }.bind(this)
        )

        // this.map.on('click', (e) => this.handleClickOnMap(e))
      }
    },
    // handleClickOnMap(e) {
    //   console.log('handleClickOnMap', e);
    // },
    onChangeMapCenter(e) {
      if (this.gpsLoading) return
      const center = e.target.getCenter()
      this.latLng = center

      const params = {
        lng: center.lng,
        lat: center.lat,
        profile: 'ahamove'
      }

      this.geocoding = true
      getPlaceGeoReverse(params)
        .then((data) => {
          this.geocodeResult = JSON.parse(JSON.stringify(data))
        })
        .then(() => {
          this.geocoding = false
          this.$_globalMixin_requestErrorHandle(e)
        })
    },
    close() {
      this.$emit('dismiss')
    },
    confirm() {
      this.$emit('confirmAddress', { ...this.latLng, ...this.geocodeResult })
    },
    getCurrentLocation($event) {
      $event && $event.stopPropagation()
      $event && $event.preventDefault()

      this.gpsLoading = true
      this.gpsOff = false
      return new Promise((resolve) => {
        if (!window.google) {
          this.loadGoogleMapApiJS().then(() => {
            resolve()
          })
        } else {
          resolve()
        }
      }).then(() => {
        this.$_addressHelper_getGPSLocation()
          .then((position) => {
            if (position && position.coords) {
              const latLng = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }

              const params = {
                ...latLng,
                profile: 'ahamove'
              }

              getPlaceGeoReverse(params)
                .then((data) => {
                  data = { ...latLng, ...data }
                  this.$emit('onChange', data)
                  this.gpsLoading = false
                  this.loading = false

                  const center = [data.lat, data.lng]
                  this.map.setView(center, 15)
                })
                .catch((e) => {
                  this.gpsLoading = false
                  this.loading = false

                  // const error = {
                  //   visible: true,
                  //   color: 'error',
                  //   timeout: 4000,
                  //   title: this.$t('dropoff_address.geocode_error')
                  // }
                  // this.$store.dispatch('setSnackbar', error)
                  this.$_globalMixin_requestErrorHandle(e)
                })
            } else this.gpsLoading = false
          })
          .catch((e) => {
            if (e && e.code === 1 && e.message === 'User denied Geolocation') {
              let error = {
                visible: true,
                color: 'error',
                timeout: 1500,
                title: this.$t('dropoff_address.form.gps_off')
              }
              this.$store.dispatch('setSnackbar', error)
            }
            console.log(e)
            this.gpsOff = true
            this.gpsLoading = false
          })

        this.$analyticTracking.logEvent(
          this.$trackingEvents.ACTIONS.CLICK,
          this.$trackingEvents.EVENTS.PICKUP_LOCATION_GPS_BTN
        )

        this.$analyticTracking.logEvent(
          this.$trackingEvents.ACTIONS.CLICK,
          this.$trackingEvents.EVENTS.SEARCH_LOCATION_SELECT_CURRENT_LOCATION,
          {}
        )
      })
    }
  },
  destroyed() {
    if (this.map) {
      if (this.map && this.map.clearLayers && typeof this.map.clearLayers === 'function') {
        this.map.clearLayers()
      }
      // this.map.remove()
    }
  },
  watch: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.gps-btn {
  .v-btn__content {
    height: auto;
  }
}
</style>

<style lang="scss" scoped>
.gps-btn .v-icon {
  height: auto;
  width: auto;
}

.relative {
  position: relative;

  #pinMap {
    width: 100%;
    height: 460px;
    z-index: 0;
    background: #eee;
  }

  .gps-btn {
    position: absolute;
    bottom: 15px;
    right: 15px;
    z-index: 40;

    .v-btn__content {
      height: auto;
    }

    .v-icon {
      font-size: 21px !important;
    }
  }

  .pin-marker {
    position: fixed;
    top: calc(50% - 50px);
    left: calc(50% - 23px);
    z-index: 40;

    img {
      height: 50px; // 32px;
      width: 46px; // 20px;
    }

    .formatted-address {
      position: absolute;
      bottom: 60px;
      width: 240px;
      background-color: rgba(0, 0, 0, 0.7);
      color: #fff;
      margin-left: calc(-120px + 23px);
      padding: 5px 10px;
      border-radius: 2px;
      font-size: 12px;
    }
  }
}

.pin-on-map__actions {
  padding: 24px;

  button {
    text-transform: none;
    height: 44px;
    min-width: 160px;
  }
}

@media screen and (max-width: 768px) {
  .pin-on-map__actions {
    padding: 16px;

    button {
      min-width: 120px;
      width: calc(50% - 4px);
    }
  }

  .leaflet-control-attribution {
    visibility: hidden;
    position: relative;
    padding-top: 2px;
    padding-bottom: 2px;
    margin: 0 10px 10px 10px;
    padding-right: 24px;
    text-align: left;
    background-color: #fff;
    border-radius: 3px 12px 12px 3px;
  }

  .leaflet-control-attribution::after {
    content: '';
    visibility: visible;
    position: absolute;
    top: 0;
    right: 0;
    background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D%270%200%2020%2020%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%0D%0A%09%3Cpath%20fill%3D%27%23333333%27%20fill-rule%3D%27evenodd%27%20d%3D%27M4%2C10a6%2C6%200%201%2C0%2012%2C0a6%2C6%200%201%2C0%20-12%2C0%20M9%2C7a1%2C1%200%201%2C0%202%2C0a1%2C1%200%201%2C0%20-2%2C0%20M9%2C10a1%2C1%200%201%2C1%202%2C0l0%2C3a1%2C1%200%201%2C1%20-2%2C0%27%20%2F%3E%0D%0A%3C%2Fsvg%3E');
    background-color: rgba(255, 255, 255, 0.5);
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 12px;
    cursor: pointer;
  }

  .leaflet-control-attribution:hover {
    visibility: visible;
  }
}
</style>
